import { render, staticRenderFns } from "./PicsBox.vue?vue&type=template&id=4e33a85d&"
import script from "./PicsBox.vue?vue&type=script&lang=ts&"
export * from "./PicsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports